import { Box, Heading, Text } from "rebass";
import { height } from "styled-system";
import styled from "styled-components";
import { DynamicNextLink } from "./dynamic-next-link";
import { LazyImage } from "./lazy-image";

//  link: { internal: boolean, href, as }
//  image: { alt: string, url: string }
//  title: string
//  details: string
//  description: string
//  cta: string
//  whiteText: bool
const Module = ({
  link,
  image,
  title,
  details,
  description,
  cta = "View More",
  whiteText = false
}) => {
  return (
    <Box>
      {image && image.url && (
        <S_DynamicNextLink link={link}>
          <ImageWrapper mb={3} height={[239]}>
            <S_LazyImage src={image.url} alt={image.alt} />
          </ImageWrapper>
        </S_DynamicNextLink>
      )}
      {title && (
        <S_Heading
          as="h2"
          mb={3}
          fontSize={[4, 4, 4, 5]}
          fontFamily="medium"
          letterSpacing={4}
          lineHeight={1}
          color={whiteText ? "white" : "blue.2"}
        >
          <S_DynamicNextLink link={link}>{title}</S_DynamicNextLink>
        </S_Heading>
      )}
      {details && (
        <Text
          fontSize={1}
          fontFamily="medium"
          color={whiteText ? "white" : "blue.1"}
          mb={3}
        >
          {details}
        </Text>
      )}
      {description && (
        <Text
          fontSize={[2, 2, 2, 3]}
          color={whiteText ? "white" : "black"}
          mb={3}
          lineHeight={1.5}
        >
          {description}
        </Text>
      )}

      {cta && (
        <Text
          color={whiteText ? "white" : "blue.1"}
          fontSize={1}
          fontFamily="medium"
        >
          <S_DynamicNextLink link={link}>{cta}</S_DynamicNextLink>
        </Text>
      )}
    </Box>
  );
};

const ImageWrapper = styled(Box)`
  ${height}
`;

const S_LazyImage = styled(LazyImage)`
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const S_Heading = styled(Heading)`
  text-transform: uppercase;
`;

const S_DynamicNextLink = styled(DynamicNextLink)`
  display: inline-block;
  a:hover {
    text-decoration: underline;
  }
`;

export { Module };
